<template>
  <div class="inquiry_index_pages">
    <van-tabs
      v-model="active"
      :line-width="'20px'"
      color="#807AF4"
      title-active-color="#807AF4"
      :border="false"
      @click="clickTabs" 
      v-if="showPages"
    >
      <van-tab title="患者本人问诊">
        <div v-if="codeUrl">
        <!-- {{codeUrl}} -->
        </div>
        <div class="fill_van_tab_content">
          <div class="fill_van_tab_bg2">
            <!-- <div v-if="!codeUrl"> -->
              <img v-if="!codeIng" :src="codeUrl" class="fill_van_tab_content_code" />
              <div class="fill_van_tab_content_loading" v-else>
                <!-- <van-loading /> -->
              </div>
            <!-- </div> -->
            <!-- <span v-else>加载失败,点击重新请求</span> -->
          </div>
          <!-- <div class="fill_van_tab_content_text" style="position:fixed;top:15%;left:10%;width:80%;line-height:1.8;text-align: center;">
            <div>亲，该功能技术小哥哥正在加班加点维护中，</div>
            <div>预计5月6日（星期三）完成，请您耐心等待！</div>
            <div>给您带来的不便尽请谅解，感谢您的理解与支持。</div>
          </div> -->

          <div class="fill_van_tab_content_text">请患者微信扫码自主向医生发起问诊</div>
          <!-- <div class="fill_van_tab_content_footer">
            <div class="fill_van_tab_content_btn1" @click="toImage">下载门店专属海报</div>
            <div class="fill_van_tab_content_btn2" @click="showCodeUrl=true">下载门店专属码</div>
          </div> -->
            <div class="operation_box">
                <div class="box_item" @click="toImage">
                  <img src="@/images/er_post.png" alt=""   >
                  <div class="fill_van_tab_content_btn1">下载海报</div>
                </div>
                <div class="box_item" @click="showCodeUrl=true" >
                  <img src="@/images/er_code.png" alt="" >
                  <div class="fill_van_tab_content_btn1" >下载二维码</div>
                </div>
                <div class="box_item"  @click="copyEvent">
                  <img src="@/images/er_link.png" alt="" >
                  <div class="fill_van_tab_content_btn1">复制链接</div>
                </div>
            </div>
        </div>
      </van-tab>
					
      <van-tab v-if="submitType == 1" title="协助问诊">
        <router-link class="flex1 buyInquiry" to="/buyInquiry" v-if="pack && !isIOS">
          <div class="buyInquiry_text_1">点击右方购买图文套餐，问诊更实惠哦</div>
          <div class="buy_btn">去购买</div>
        </router-link>




        <div class="containers">
          <div class="item_box flex2" v-for="item in list" :key="item.title" @click="gotoFill(item)">
            <img src="@/images/index_3.png" alt="" class="recommend_img" v-if="item.showRecommend">
            <img :src="item.img" class="index_img_1">
            <div class="flex1 text_box_1">
              <div>
                <div class="index_title_1">
                  <span>{{item.title}}</span>
                  <span v-if="!isIOS" class="price">{{item.price}}元/次</span>
                </div>
                <div class="index_content_1 flex2">本月剩余<span  class="other_col" >{{item.count}}</span>次</div>
              </div>
              <img src="@/images/arrow2.png" class="index_arr_img_1">
            </div>
          </div>
          <div class="item_tip">温馨提示：店员可协助打字或输入不便的患者提交问诊信息，等候医生的回复。</div>
        </div>


        <!-- <div class="index_tip" @click="gotoHelp">问诊帮助中心 ></div> -->


      </van-tab>
    </van-tabs>
    <div class="imageWrapper" v-if="codeUrl" ref="imageWrapper">
      <img class="imageWrapper_bg" src="@/images/poster.jpg" alt="">
      <img class="imageWrapper_code" :src="codeUrl"/>
    </div>
    <!-- 专属海报弹出层 -->
    <van-popup v-model="showPosterUrl" class="posterUrl_popup">
      <img v-if="posterUrl" :src="posterUrl" alt="">
      <!-- <van-loading v-else/> -->
      <div v-if="posterUrl">
        <van-icon name="upgrade" /><br>
        长按上方图片保存到相册
      </div>
    </van-popup>
    <!-- 二维码弹出层 -->
    <van-popup v-model="showCodeUrl">
      <div v-if="codeUrl">
        <img :src="codeUrl" alt="">
        <van-icon name="upgrade" /><br>
        <div>长按上方图片保存到相册</div>
      </div>
      <div v-else>加载失败, 请重新请求</div>
    </van-popup>

    <!-- 支付弹窗 -->
    <pay-money-module
      @pay="wChatPay"
      v-if="showPayModule"
      :payTitle="payTitle"
      :payMoney="payMoney"
    ></pay-money-module>

    <!-- 提示弹窗 -->
    <van-dialog v-model="showTipModule" messageAlign="center" :showConfirmButton="false">
      <div class="dialog_box">
        <div class="tip_text">医生视频接诊时间为<span style="color:#108ee9">8:00-22:00</span></div>
        <div class="tip_text">请在医生上班时间内发起问诊哦</div>
        <div class="tip_btn" @click="showTipModule = false">知道了</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getCookie, setCookie, getToken, getBrowser} from "@/utils/common.js";
import index1Img from "@/images/index_1.png";
import index2Img from "@/images/index_2.png";
import {GetInquiryQrCode,GetPackage,GetSilkBagShortchain,IOSLogin,GetInquiryWxOpenQrCode,GetInquiryWxOpenQrCode_Base64,UnifiedOrder} from "@/utils/api.js"
import { Toast, Dialog} from "vant";
import html2canvas from "html2canvas";
import payMoneyModule from "@/components/payMoneyModule.vue";
export default {
  data() {
    return {
      copyUrl:'',//复制路径
      showTipModule:false,//时间段提示框
      showPayModule:false,//支付弹框
      payTitle:'',//支付弹框标题
      payMoney:'',//支付金额
      submitType:null,
      isIOS:false,//不是ios
      pack:false,//是否存在包
      active: 0,
      codeUrl: "",
      codeIng:false,
      showPages:false,
      posterUrl:'',//海报地址
      showPosterUrl:false,//专属海报
      showCodeUrl:false,//二维码弹出层
      list:[
        {
          title:"图文问诊",
          count:'*',
          content2:"",
          img:index2Img,
          showRecommend:true,
          ModeType:1,
          price:"*"
        },
        {
          title:"视频问诊",
          content:"20元/次，每次5分钟",
          count:"*",
          img:index1Img,
          showRecommend:false,
          ModeType:5,
          price:"*"
        }

      ],
      modeType:''
    };
  },
  components:{
    payMoneyModule
  },
  methods: {
    toImage() {
      // debugger
      this.showPosterUrl=true
      var cliewidth=this.$refs.imageWrapper.offsetWidth
      var clieheight=this.$refs.imageWrapper.offsetHeight
      // var scale = 2
      var kh=[cliewidth,clieheight]
      // console.log(kh);
      html2canvas(this.$refs.imageWrapper
      ,{
        useCORS: true,
        dpi : window.devicePixelRatio * 2,
        scale : 3,
        width : cliewidth,
        height : clieheight
      }
      ).then(res=>{
        let posterUrl = res.toDataURL('image/png')
        this.posterUrl = posterUrl;
        // console.log(posterUrl);
      })
    },
  copyEvent(){
      var input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", this.copyUrl);
      document.body.appendChild(input);
      document.execCommand('selectAll');
      input.focus(); // 少了这行代码复制不了
      input.setSelectionRange(0, input.value.length);
      console.log(this.copyUrl)
      if(!this.copyUrl){
        this.getShortLink()
        Toast("复制失败,请重试!");
        return
      }
      if (document.execCommand("copy")) {
        Toast("复制成功!");
      }else{
        Toast("复制失败,请重试!");
        this.getShortLink()
      }
      document.body.removeChild(input);
  },
   async getShortLink(){
      let res = await GetSilkBagShortchain()
      if(res.code == 1){this.copyUrl = res.data.Url}
    },
    getUrlBase64(url,kh) { 
      return new Promise(resolve => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url
        img.onload = function() {
          canvas.height = kh[1]
          canvas.width = kh[0]
          ctx.drawImage(img, 0, 0, kh[0], kh[1])
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },
    download(imgurl,kh) {
      this.getUrlBase64(imgurl,kh).then(base64 => {
        let link = document.createElement('a')
        link.href = base64
        this.posterUrl = base64;
        this.showPosterUrl=true
        link.download = '门店专属海报.png'
        // link.click()
      })
    },
    getpakes(){  
      GetPackage({shopId:getCookie("shopId")}).then(res=>{
        if(res.code==1){
          if(!res.data){
            this.list[0].count = 0
            this.list[1].count = 0
            this.list[0].price = res.data.GraphicPackage.PackagePrice
            this.list[1].price = res.data.VideoPackage.PackagePrice
            this.pack = true

          }else{
            if(res.data.ShopPackage){
            this.list[0].count = res.data.ShopPackage.GraphicRemainingQuantity
            this.list[1].count = res.data.ShopPackage.VideoRemainingQuantity
             this.pack = res.data.ShopPackage.PackageMode==2?true:false
            }else{
            this.list[0].count = 0
            this.list[1].count = 0
            this.pack = true
            }
            this.submitType = res.data.SubmitType
            this.list[0].price = res.data.GraphicPackage.PackagePrice
            this.list[1].price = res.data.VideoPackage.PackagePrice
          }
        }else{
          Toast(res.msg)
        }
        
      })
    },
    //支付
    wChatPay(type) {
      let that = this;
      if (type == 0) {
        this.showPayModule = false;
      } else if (type == 1) {
        let PackageCode = this.modeType == 5 ? "000003" : "000001";
        let datas = {
          OrderId: "",
          PackageCode,
          AppName: "莲藕健康",
          IpAddress: "192.168.1.5",
          ShopId: getCookie("shopId")
        };
        UnifiedOrder(datas).then(res => {
          console.log(res);
          if (res.code == 1) {
            window.wxPaySuccess = function(res) {
              that.showPayModule = false;
              Dialog.alert({
                title: "购买成功"
              }).then(() => {
                that.toApplet();
              });
            };
            window.wxPayFail = function(err) {
              Toast.clear();
              setTimeout(() => {
                Toast(err);
              }, 500);
            };
            let Browser = getBrowser();
            let data = res.data;

            let appid = data.AppId;

            let partnerId = data.PartnerId;

            let prepayId = data.PrepayId;

            let nonceStr = data.NonceStr;

            let packageValue = data.Package;

            let timeStamp = data.TimeStamp;

            let sign = data.Sign;
            let jsonData = JSON.stringify({
              appid,
              partnerId,
              prepayId,
              nonceStr,
              packageValue,
              timeStamp,
              sign
            });
            console.log(jsonData);
            if (Browser.isAndroid && window.jsObj) {
              window.pay.wechatPay(jsonData);
            } else if (Browser.isIOS && getCookie("access_token")) {
              window.webkit.messageHandlers.wechatPay.postMessage(jsonData);
            } else {
              Toast("请在莲藕医生（药店端）中进行支付操作");
            }
          } else {
            Toast(res.msg);
          }
        });
      }
    },
    //根据店铺权限 决定是跳小程序还是在app
    toApplet(){
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let shopId = getCookie("shopId")
      let shopUserId = getCookie("shopUserId")
      let userId = shopUserId.replace(shopId,'')
      let Channel = '26203'
      let video = this.modeType == 5
      let scene = encodeURIComponent(`${shopId}&${userId}&${Channel}`)
      let json = JSON.stringify({
        userName:process.env.VUE_APP_APPID,
        path:`/pages/InquiryPackage/InquiryForm/index?video=${video}&scene=${scene}`
      })
      console.log(shopId);
      console.log(userId);
      console.log(json);
      if(this.submitType == 1){//=1时跳转小程序
        if(isiOS){//调用ios
          if(window.prompt && window.prompt("isInstallWechat") == 1){
            console.log('isiOS',true);
            // if(video){//苹果微信暂不支持视频
            //   this.$router.push({path:"/fill",query:{ModeType:this.modeType}})
            // }else{
              window.webkit.messageHandlers.launchMiniProgram.postMessage(json);
            // }
          }else{//兼容旧版本
            this.$router.push({path:"/fill",query:{ModeType:this.modeType}})
          }
        }

        if(isAndroid){//调用Android
          if(window.wechat && window.wechat.isInstallWechat() == 1){
            console.log('isAndroid',true);
            window.wechat.launchMiniProgram(json)
          }else{//兼容旧版本
            this.$router.push({path:"/fill",query:{ModeType:this.modeType}})
          }
        }

      }else{
        this.$router.push({path:"/fill",query:{ModeType:this.modeType}})
      }
    },
    //比较当前时间是否在指定时间段内
    isDuringDate(beginDateStr, endDateStr) {
      let year = new Date().getFullYear()
      let mon = new Date().getMonth()+1
      let data = new Date().getDate()
      beginDateStr = `${year}/${mon}/${data} ${beginDateStr} `
      endDateStr = `${year}/${mon}/${data} ${endDateStr} `
      var curDate = new Date(),
          beginDate = new Date(beginDateStr),
          endDate = new Date(endDateStr);
      console.log(curDate);
      console.log(endDateStr);
      if (curDate >= beginDate && curDate <= endDate) {
          return true;
      }
      return false;
    },
    gotoFill(item){
      console.log(item);
      //根据剩余套餐数量 没有问诊次数的先购买
      this.modeType = item.ModeType
      //目前医生视频问诊接诊时间为8:00-22:00，以免客户在医生下班发起问诊，误以为没有医生接诊
      console.log(this.isDuringDate('07:59:59','22:00:00'));
      if(item.ModeType == 5 && !this.isDuringDate('07:59:59','22:00:00')) {//视频问诊
        this.showTipModule = true
        return
      }
      if(!item.count){
        this.payTitle = item.ModeType==5?'视频问诊':'图文问诊'
        this.payMoney = item.price
        this.showPayModule = true
        return
      }
      // return
      //根据店铺权限 决定是跳小程序还是在app
      this.toApplet()

      this.$store.commit("changeInts",0)
      sessionStorage.removeItem('his_people')
    },
    // 点击头部导航栏
    clickTabs(i) {
      console.log(i);
      if (i == 0) {
        this.getCode()
      }
    },
    getCode() {
      // if(this.codeUrl) return
      this.codeUrl = ""
      console.log("请求二维码接口");
      // if (this.codeIng) {
      //   //如果正在请求，则退出
      //   console.log("有正在请求的接口，直接退出，等待接口返回");
      //   return;
      // }
      this.codeIng = true;
      GetInquiryWxOpenQrCode_Base64().then(res=>{
        console.log(res)
        if(res.code==1){
          this.codeIng = false;
          this.codeUrl = "data:image/png;base64,"+res.data;
          // localStorage.setItem('posterUrl',"data:image/png;base64,"+res.data)
          // this.codeUrl = localStorage.getItem('posterUrl');
          // this.toImage()
          // this.codeUrl = res.data
        }else{
          Toast(res.msg)
          this.codeIng = false;
        }
      })
    },

    gotoHelp() {
      window.location.href = "https://lian-ou.com/v2/feature/auquh6Upus";
    },
  },
  mounted() {
    this.getShortLink()
    // 
    // GetJSConfig({
    //   AppKey: 123456,
    //   Url: window.location.href
    // }).then(res => {
    //   let data = JSON.parse(res.data);
    //   console.log(data);
    //   var appId = data.appid,
    //     nonceStr = data.noncestr,
    //     signature = data.signature,
    //     timestamp = data.timestamp;
    //   wx.config({
    //     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //     appId: appId, // 必填，公众号的唯一标识
    //     timestamp: timestamp, // 必填，生成签名的时间戳
    //     nonceStr: nonceStr, // 必填，生成签名的随机串
    //     signature: signature, // 必填，签名，见附录1
    //     jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    //   });
    // });
    this.getCode()
    const UA = navigator.userAgent || '';
     var is_IOS = !!UA.match(/iPhone|iPad|iPod/i);
    if(is_IOS){
      // debugger
      IOSLogin({version:getCookie('version')}).then(res =>{
        // debugger
        if(res.data == 1){
          this.isIOS = true
        }
      })
    }
    
    this.getpakes()
    sessionStorage.removeItem("fillData");
    sessionStorage.removeItem("unUpdate");
    sessionStorage.removeItem("firstHis");
    this.showPages = true
    window.watchs();
    document.title = "快速问诊";
    window.addEventListener("DOMContentLoaded", function () {
  const button = document.body.appendChild(document.createElement("button"));
  button.textContent = "Copy";
  button.addEventListener("click", this.handler);
});
  },
  beforeDestroy() {
    // sessionStorage.removeItem("fillData");
    // sessionStorage.removeItem("unUpdate");
  }
};
</script>
<style lang="scss" scoped src="@/scss/inquiry_index.scss">

</style>
<style lang="scss" scoped>
.dialog_box {
  text-align: center;
  padding: 20px 14px;
  .tip_text {
    text-align: center;
    width: 100%;
    margin-bottom: 2px;
  }
  .tip_btn {
    background: #108ee9;
    color: #fff;
    width: 60px;
    margin: 24px auto 0;
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 14px;
  }
}
</style>

